import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { useFlipperFlag } from './useFlipperFlag'

export const useEmailIntegrations = () => {
  const { data } = useExternalIntegrations()
  const zapierPickerEnabled = useFlipperFlag('zapier_v2')
  const integrations = data?.external_integrations

  if (!integrations) {
    return {
      connectedEmailIntegration: null,
      hasEmailIntegrationConnected: false,
    }
  }

  const mailchimpIntegration =
    integrations.find((integration) => integration.provider === ExternalIntegrationEnum.Mailchimp) ?? null

  // A Zapier integration counts as the workspace's newsletter destination only
  // when the picker is enabled AND it's explicitly flagged is_email_destination
  // via ZapierTargetsPicker.
  const zapierNewsletterIntegration = zapierPickerEnabled
    ? integrations.find((integration) => {
        if (integration.provider !== ExternalIntegrationEnum.Zapier) return false
        const additionalData = integration.additional_data as { is_email_destination?: boolean } | undefined
        return additionalData?.is_email_destination === true
      }) ?? null
    : null

  const connectedEmailIntegration = mailchimpIntegration ?? zapierNewsletterIntegration

  return {
    connectedEmailIntegration,
    hasEmailIntegrationConnected: connectedEmailIntegration !== null,
  }
}
